// src/mocks/handlers/dashboard/requestFunds_requestFunds.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { RequestFundsFromValues } from '@/domains/dashboard/requestFunding/requestFunding.types';
import { genericResponse } from '@/shared/types/api';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const requestFundsRequestFundsHandler = rest.post<
  RequestFundsFromValues,
  genericResponse
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_AVAILABLE_FUNDS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    // Simulate a successful request
    return res(
      ctx.status(200),
      ctx.json({
        message: 'Request for funds has been submitted successfully',
      }),
    );
  },
);
